import {CommonTaskDetails} from '/component/screen/ClientProfile/ClientJourney/TaskDetails/FirstWeekTaskDetails/CommonTaskDetails';
import {DayFiveCheckInDetails} from '/component/screen/ClientProfile/ClientJourney/TaskDetails/FirstWeekTaskDetails/DayFiveCheckInDetails';
import {DayOneCheckInDetails} from '/component/screen/ClientProfile/ClientJourney/TaskDetails/FirstWeekTaskDetails/DayOneCheckInDetails';
import {FirstWeekCelebrationDetails} from '/component/screen/ClientProfile/ClientJourney/TaskDetails/FirstWeekTaskDetails/FirstWeekCelebrationDetails';
import {JourneyKickOffCallDetails} from '/component/screen/ClientProfile/ClientJourney/TaskDetails/FirstWeekTaskDetails/JourneyKickOffCallDetails';
import {HealthAssessmentTaskDetails} from '/component/screen/ClientProfile/ClientJourney/TaskDetails/PreJourneyTaskDetails/HealthAssessmentTaskDetails';
import {ShareOptaviaTaskDetails} from '/component/screen/ClientProfile/ClientJourney/TaskDetails/PreJourneyTaskDetails/ShareOptaviaTaskDetails';
import {WelcomeMessageTaskDetails} from '/component/screen/ClientProfile/ClientJourney/TaskDetails/PreJourneyTaskDetails/WelcomeMessageTaskDetails';
import {WeeklyCheckInTaskDetails} from '/component/screen/ClientProfile/ClientJourney/TaskDetails/WeeklyCheckInsTaskDetails/WeeklyCheckInTaskDetails';

export const TASK_TYPE = {
  ['Complete Health Assessment']: HealthAssessmentTaskDetails,
  ['Welcome message & shopping list']: WelcomeMessageTaskDetails,
  ['Share the OPTAVIA App']: ShareOptaviaTaskDetails,
  ['Journey Kickoff Call']: JourneyKickOffCallDetails,
  ['Day one check-in']: DayOneCheckInDetails,
  ['Day two check-in']: CommonTaskDetails,
  ['Day three check-in']: CommonTaskDetails,
  ['Day four check-in']: CommonTaskDetails,
  ['Day five check-in']: DayFiveCheckInDetails,
  ['First week Celebration']: FirstWeekCelebrationDetails,
  ['Weekly check-in']: WeeklyCheckInTaskDetails,
};
